import React from 'react'
import "./Certificates.css"
import Project from "./Project"
import Django from "./DjangoCertificate.jpg"


function Certificates() {
    return (
        <div className="certificates">
            <Project
                img={Django}
                title="Full-stack Bootcamp"
                description="A complete bootcamp that made me learn html,css,javascript,bootstrap and django with hands onn project workk also.
                                 Project Made   -: a)Weather App
                                             b) E-com Web App "
            />
        </div>
    )
}

export default Certificates
